import { IconSvg, IconSvgProps } from "./icon"

export default function Info(props: IconSvgProps) {
  return (
    <IconSvg {...props}>
      <path d="M12 20.357a8.357 8.357 0 1 0 0-16.714 8.357 8.357 0 0 0 0 16.714ZM12 12v4.5" />
      <path d="M12 9.429a.643.643 0 1 0 0-1.286.643.643 0 0 0 0 1.286Z" />
    </IconSvg>
  )
}
